import {vpost} from "@/util/post";

export const vip = {
    plan: {
        list(type) {
            let dto = {
                type
            }
            return vpost('/admin/vip/plan/list', dto)
        },

        save(id, name, vipType, duration, price, isPromotion) {
            let dto = {
                id, vipType, duration, price, isPromotion, name
            }

            return vpost('/admin/vip/plan/save', dto)
        },

        get(id) {
            return vpost('/admin/vip/plan/get?id=' + id);
        },

        delete(id) {
            return vpost('/admin/vip/plan/delete?id=' + id);
        },
    },

    order: {
        list(
            miuAuthType,
            keyword,
            payStatus,
            pageCurrent,
            pageSize
        ) {
            let dto = {
                miuAuthType,
                keyword,
                payStatus,
                pageCurrent,
                pageSize,
            }

            return vpost("/admin/vip/order/list", dto);
        },

        detail(id) {
            return vpost("/admin/vip/order/detail?id=" + id);
        },

        use(id) {
            return vpost("/admin/vip/order/use?id=" + id);
        },
    },

    auth: {
        list(
            keyword,
            type,
            pageCurrent,
            pageSize
        ) {
            let dto = {
                keyword,
                type,
                pageCurrent,
                pageSize
            }
            return vpost("/admin/vip/auth/list", dto)
        },
    },


}
